import { useEffect } from 'react';

// Global scroll-reveal: mirrors the original site's inline script. Any element
// with className="scroll-reveal" gets ".is-visible" added once it scrolls into
// view; a MutationObserver re-scans so elements added after route changes
// (new pages mounting scroll-reveal nodes) are picked up too.
export default function useScrollReveal() {
  useEffect(() => {
    const seen = new WeakSet();
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            io.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15 }
    );

    function scan() {
      document.querySelectorAll('.scroll-reveal:not(.is-visible)').forEach((el) => {
        if (!seen.has(el)) {
          seen.add(el);
          io.observe(el);
        }
      });
    }

    scan();
    const mo = new MutationObserver(scan);
    mo.observe(document.body, { childList: true, subtree: true });

    return () => {
      io.disconnect();
      mo.disconnect();
    };
  }, []);
}
